if (!customElements.get('coody-footer')) {
  customElements.define('coody-footer', class extends HTMLElement {
    connectedCallback() {
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.sync = () => this.querySelectorAll('.simp-footer__group').forEach(group => {
        group.open = !this.mobile.matches;
        group.querySelector('summary').tabIndex = this.mobile.matches ? 0 : -1;
      });
      this.sync();
      this.mobile.addEventListener('change', this.sync);
    }
    disconnectedCallback() { this.mobile?.removeEventListener('change', this.sync); }
  });
}
